
 	<div widget class="card border-0 box-shadow h-75 "  style="display: flex; justify-content: center; align-items: center;">
 		<h1 class="text-center " translate>navegabilidad.usuarioNoAutorizado</h1>
 		<h2 class="text-center " translate>navegabilidad.usuarioNoAutorizado</h2>
 		<h3 class="text-center " translate>navegabilidad.usuarioNoAutorizado</h3>
 	</div>
